import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import { authRoles } from './auth/authRoles';
import Loadable from './components/Loadable';
import MatxLayout from './components/MatxLayout/MatxLayout';
import materialRoutes from 'app/views/material-kit/MaterialRoutes';

// session pages
const NotFound = Loadable(lazy(() => import('app/views/sessions/NotFound')));
const JwtLogin = Loadable(lazy(() => import('app/views/sessions/JwtLogin')));
const JwtRegister = Loadable(lazy(() => import('app/views/sessions/JwtRegister')));
const ForgotPassword = Loadable(lazy(() => import('app/views/sessions/ForgotPassword')));

// coming soon page
const ComingSoon = Loadable(lazy(() => import('app/views/ComingSoon')));

// ===== ACTIVE PAGES (auth + mitra only) =====

// dashboard page (temporarily disabled)
// const Analytics = Loadable(lazy(() => import('app/views/dashboard/Analytics')));

// mitra pages
const AppListMitra = Loadable(
  lazy(() => import('app/views/dashboard/menu_mitra/table_mitra/AppListMitra'))
);
const AppListMitraConfPayment = Loadable(
  lazy(() => import('./views/dashboard/menu_mitra/table_conf_payment/AppTableConfMitraPayment'))
);

// ===== TEMPORARILY DISABLED PAGES (original code tetap ada) =====
// const AppEchart = Loadable(lazy(() => import('app/views/charts/echarts/AppEchart')));
// const AppListAreas = Loadable(lazy(() => import('app/views/dashboard/menu_areas/AppListAreas')));
// const AppSystem = Loadable(lazy(() => import('app/views/dashboard/menu_it/system/AppSystem')));
// const AppPayment = Loadable(lazy(() => import('app/views/dashboard/menu_it/payment/AppPayment')));
// const AppLogsActivity = Loadable(lazy(() => import('app/views/dashboard/menu_admins/logs/admin/AppLogs')));
// const AppLogsAPI = Loadable(lazy(() => import('app/views/dashboard/menu_admins/logs/api/AppLogs')));
// const AppListClient = Loadable(lazy(() => import('./views/dashboard/menu_clients/lis_client/AppListClient')));
// const AppListReportShipping = Loadable(lazy(() => import('app/views/dashboard/reports/reports_shipping/AppListTransaction')));
// const AppReportListTransactionVA = Loadable(lazy(() => import('app/views/dashboard/reports/reports_transaction/AppListTransaction')));
// const AppListAdmins = Loadable(lazy(() => import('app/views/dashboard/menu_admins/list_admin/AppTableAdmin')));
// const AppListTransaction = Loadable(lazy(() => import('app/views/dashboard/menu_trasanctions/list_transactions/AppListTransaction')));
// const AppListComission = Loadable(lazy(() => import('app/views/dashboard/reports/reports_comission/AppListComission')));
// const AppShipping = Loadable(lazy(() => import('app/views/dashboard/menu_it/shipping/AppShipping')));
// const AppIntegrationInbound = Loadable(lazy(() => import('app/views/dashboard/menu_it/integration/inbound/AppInbound')));
// const AppIntegrationOutbound = Loadable(lazy(() => import('app/views/dashboard/menu_it/integration/outbound/AppOutbound')));

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...materialRoutes,

      // ===== ACTIVE ROUTES =====

      // dashboard (COMING SOON)
      {
        path: '/dashboard/default',
        element: <ComingSoon />,
        auth: authRoles.admin
      },

      // mitra (TETAP AKTIF)
      {
        path: '/dashboard/mitra',
        element: <AppListMitra />
      },
      {
        path: '/dashboard/conf_payment/mitra',
        element: <AppListMitraConfPayment />
      },

      // ===== COMING SOON ROUTES (code asli tetap ada, hanya redirect) =====

      // reports
      {
        path: '/dashboard/report-shipping',
        element: <ComingSoon />
      },
      {
        path: '/dashboard/report-transaction-va',
        element: <ComingSoon />
      },
      {
        path: '/dashboard/report-comission',
        element: <ComingSoon />
      },

      // client
      {
        path: '/dashboard/client',
        element: <ComingSoon />
      },

      // admin
      {
        path: '/dashboard/list-admins',
        element: <ComingSoon />
      },
      {
        path: '/dashboard/logs-activity',
        element: <ComingSoon />
      },
      {
        path: '/dashboard/logs-api',
        element: <ComingSoon />
      },

      // transactions
      {
        path: '/dashboard/list-transaction-mitra',
        element: <ComingSoon />
      },

      // areas
      {
        path: '/dashboard/list-area',
        element: <ComingSoon />
      },

      // IT config
      {
        path: '/dashboard/system',
        element: <ComingSoon />
      },
      {
        path: '/dashboard/shipping',
        element: <ComingSoon />
      },
      {
        path: '/dashboard/payment',
        element: <ComingSoon />
      },
      {
        path: '/dashboard/integration/inbound',
        element: <ComingSoon />
      },
      {
        path: '/dashboard/integration/outbound',
        element: <ComingSoon />
      },

      // e-chart
      {
        path: '/charts/echarts',
        element: <ComingSoon />,
        auth: authRoles.editor
      }
    ]
  },

  // session pages route (TETAP AKTIF)
  { path: '/authentication/404', element: <NotFound /> },
  { path: '/authentication/signin', element: <JwtLogin /> },
  { path: '/authentication/signup', element: <JwtRegister /> },
  { path: '/authentication/forgot-password', element: <ForgotPassword /> },

  { path: '/', element: <Navigate to="dashboard/mitra" /> },
  { path: '*', element: <NotFound /> }
];

export default routes;
